import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import * as z from "zod/v4";

export const getFeatureFlag = {
  name: "getFeatureFlag" as const,
  input: z.object({ flagKey: z.nativeEnum(FeatureFlagKey) }),
  output: z.object({ enabled: z.boolean() }),
};
